import { render } from "./ChoirMembersPage.vue?vue&type=template&id=94f46626"
import script from "./ChoirMembersPage.vue?vue&type=script&lang=js"
export * from "./ChoirMembersPage.vue?vue&type=script&lang=js"

import "./ChoirMembersPage.vue?vue&type=style&index=0&id=94f46626&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__